import React from 'react';
import { motion } from 'framer-motion';
import { UsersIcon, CalendarIcon, StarIcon } from 'lucide-react';
export function ProofGallery() {
  return <section className="bg-[#0A0A0A] py-20 md:py-28" data-id="element-262">
      <div className="max-w-6xl mx-auto px-6" data-id="element-263">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-264">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-[#F5F5F0] tracking-tight mb-4" data-id="element-265">
            Real Results — Real Timelines
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-20" data-id="element-266">
          {/* Card 1 */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-80px'
        }} transition={{
          duration: 0.5,
          delay: 0
        }} className="bg-[#1A1A1A] border border-[#2A2A2A] rounded-lg overflow-hidden" data-id="element-267">
            <div className="grid grid-cols-2" data-id="element-268">
              <div className="aspect-square bg-[#111111] border-r border-[#2A2A2A] relative overflow-hidden" data-id="element-269">
                <img src="https://cdn.magicpatterns.com/uploads/eRJo1PsL6BhR6dzboMR5Xc/Screenshot_2026-02-18_130014.png" alt="Before results - Card 1" className="w-full h-full object-cover" data-id="element-270" />
                <div className="absolute top-3 left-3 bg-black/60 px-2 py-1 rounded backdrop-blur-sm" data-id="element-271">
                  <span className="text-[10px] font-bold tracking-widest uppercase text-white" data-id="element-272">
                    Before
                  </span>
                </div>
              </div>
              <div className="aspect-square bg-[#111111] relative overflow-hidden" data-id="element-273">
                <img src="https://cdn.magicpatterns.com/uploads/eUCVaQKr6UBq5KRihoSQNZ/Screenshot_2026-02-18_130030.png" alt="After results - Card 1" className="w-full h-full object-cover" data-id="element-274" />
                <div className="absolute top-3 left-3 bg-black/60 px-2 py-1 rounded backdrop-blur-sm" data-id="element-275">
                  <span className="text-[10px] font-bold tracking-widest uppercase text-[#C8A04A]" data-id="element-276">
                    After
                  </span>
                </div>
              </div>
            </div>
            <div className="p-5" data-id="element-277">
              <p className="text-sm text-[#9CA3AF] leading-relaxed" data-id="element-278">
                David Watson, 53 — Wales. Norwood 3 at start. Photos taken at
                baseline and month 5. Used CrownControl™ 20 minutes/day, 5x per
                week.
              </p>
            </div>
          </motion.div>

          {/* Card 2 */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-80px'
        }} transition={{
          duration: 0.5,
          delay: 0.1
        }} className="bg-[#1A1A1A] border border-[#2A2A2A] rounded-lg overflow-hidden" data-id="element-279">
            <div className="grid grid-cols-2" data-id="element-280">
              <div className="aspect-square bg-[#111111] border-r border-[#2A2A2A] relative overflow-hidden" data-id="element-281">
                <img src="https://cdn.magicpatterns.com/uploads/rFTZY2kWG9QjKHizJHUgap/Screenshot_2026-02-18_131703.png" alt="Before results - Card 2" className="w-full h-full object-cover" data-id="element-282" />
                <div className="absolute top-3 left-3 bg-black/60 px-2 py-1 rounded backdrop-blur-sm" data-id="element-283">
                  <span className="text-[10px] font-bold tracking-widest uppercase text-white" data-id="element-284">
                    Before
                  </span>
                </div>
              </div>
              <div className="aspect-square bg-[#111111] relative overflow-hidden" data-id="element-285">
                <img src="https://cdn.magicpatterns.com/uploads/1SQdFpr4Dv9wmSAcjC8Zjx/Screenshot_2026-02-18_131711.png" alt="After results - Card 2" className="w-full h-full object-cover" data-id="element-286" />
                <div className="absolute top-3 left-3 bg-black/60 px-2 py-1 rounded backdrop-blur-sm" data-id="element-287">
                  <span className="text-[10px] font-bold tracking-widest uppercase text-[#C8A04A]" data-id="element-288">
                    After
                  </span>
                </div>
              </div>
            </div>
            <div className="p-5" data-id="element-289">
              <p className="text-sm text-[#9CA3AF] leading-relaxed" data-id="element-290">
                Jamie, 46 — London. Norwood 3 at start. Photos taken at baseline
                and month 6. Used CrownControl™ 10 minutes/day, 5x per week.
              </p>
            </div>
          </motion.div>

          {/* Card 3 */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-80px'
        }} transition={{
          duration: 0.5,
          delay: 0.2
        }} className="bg-[#1A1A1A] border border-[#2A2A2A] rounded-lg overflow-hidden" data-id="element-291">
            <div className="grid grid-cols-2" data-id="element-292">
              <div className="aspect-square bg-[#111111] border-r border-[#2A2A2A] relative overflow-hidden" data-id="element-293">
                <img src="https://cdn.magicpatterns.com/uploads/9WJ3vNiBGP3Z1BCzo5rXPm/Screenshot_2026-02-18_132945.png" alt="Before results - Card 3" className="w-full h-full object-cover" data-id="element-294" />
                <div className="absolute top-3 left-3 bg-black/60 px-2 py-1 rounded backdrop-blur-sm" data-id="element-295">
                  <span className="text-[10px] font-bold tracking-widest uppercase text-white" data-id="element-296">
                    Before
                  </span>
                </div>
              </div>
              <div className="aspect-square bg-[#111111] relative overflow-hidden" data-id="element-297">
                <img src="https://cdn.magicpatterns.com/uploads/6KjqcC5w9ff8kYXvDQdzci/Screenshot_2026-02-18_133002.png" alt="After results - Card 3" className="w-full h-full object-cover" data-id="element-298" />
                <div className="absolute top-3 left-3 bg-black/60 px-2 py-1 rounded backdrop-blur-sm" data-id="element-299">
                  <span className="text-[10px] font-bold tracking-widest uppercase text-[#C8A04A]" data-id="element-300">
                    After
                  </span>
                </div>
              </div>
            </div>
            <div className="p-5" data-id="element-301">
              <p className="text-sm text-[#9CA3AF] leading-relaxed" data-id="element-302">
                Abdul, 38 — U.S. Norwood 4 at start. Photos taken at baseline
                and month 5. Used CrownControl™ 10 minutes/day, 5x per week.
              </p>
            </div>
          </motion.div>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.6
      }} data-id="element-303">
          <h3 className="text-2xl md:text-3xl font-bold text-[#F5F5F0] tracking-tight text-center mb-12" data-id="element-304">
            By the Numbers
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-305">
            <div className="text-center" data-id="element-306">
              <div className="flex items-center justify-center gap-3 mb-3" data-id="element-307">
                <UsersIcon className="w-6 h-6 text-[#C8A04A]" data-id="element-308" />
              </div>
              <p className="text-4xl md:text-5xl font-bold text-[#C8A04A] mb-2" data-id="element-309">
                5,250+
              </p>
              <p className="text-[#9CA3AF]" data-id="element-310">men currently on protocol</p>
            </div>
            <div className="text-center" data-id="element-311">
              <div className="flex items-center justify-center gap-3 mb-3" data-id="element-312">
                <CalendarIcon className="w-6 h-6 text-[#C8A04A]" data-id="element-313" />
              </div>
              <p className="text-4xl md:text-5xl font-bold text-[#C8A04A] mb-2" data-id="element-314">
                16,000+
              </p>
              <p className="text-[#9CA3AF]" data-id="element-315">completed sessions</p>
            </div>
            <div className="text-center" data-id="element-316">
              <div className="flex items-center justify-center gap-3 mb-3" data-id="element-317">
                <StarIcon className="w-6 h-6 text-[#C8A04A]" data-id="element-318" />
              </div>
              <p className="text-4xl md:text-5xl font-bold text-[#C8A04A] mb-2" data-id="element-319">
                83%
              </p>
              <p className="text-[#9CA3AF]" data-id="element-320">would recommend to a friend</p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}